let logoutCallback = null;

export const setLogoutCallback = (callback) => {
  logoutCallback = callback;
};

export const authFetch = async (url, options = {}) => {
  const response = await fetch(url, options);
  if (response.status === 401 && logoutCallback) {
    logoutCallback();
    return null;
  }
  return response;
};
